import { UnreachableCaseError } from 'ts-essentials';

import type { FxWorkspaceLoadStatus } from './fx-workspace.types';

export const FX_WORKSPACES_QUERY_KEY = 'fx-workspaces';
export const FX_WORKSPACE_REFERENCES_QUERY_KEY = 'fx-workspace-references';
export const FX_WORKSPACE_BREAKLINES_QUERY_KEY = 'fx-workspace-breaklines';

export interface FxWorkspaceDetailsKey {
  readonly key: string;
  readonly workspaceId: string;
}

export function fxWorkspacesQueryKey(
  repositoryKey: string
): readonly [string, string] {
  return [FX_WORKSPACES_QUERY_KEY, repositoryKey];
}

export function fxWorkspaceReferencesQueryKey(
  repositoryKey: string,
  workspaceId: string
): readonly [string, string, string] {
  return [FX_WORKSPACE_REFERENCES_QUERY_KEY, repositoryKey, workspaceId];
}

export function fxWorkspaceBreaklinesQueryKey(
  repositoryKey: string,
  workspaceId: string
): readonly [string, string, string] {
  return [FX_WORKSPACE_BREAKLINES_QUERY_KEY, repositoryKey, workspaceId];
}

// Map query `status`, not `isFetching`. Background refetches keep status
// `success` while isFetching is true; treating fetch as pending cleared
// detailsKey and replaced the Workspaces tree with a spinner.
export function toQueryLoadStatus(
  status: 'pending' | 'error' | 'success'
): FxWorkspaceLoadStatus {
  switch (status) {
    case 'pending':
      return 'pending';
    case 'error':
      return 'error';
    case 'success':
      return 'success';
    default:
      throw new UnreachableCaseError(status);
  }
}

export function combineWorkspaceDetailsLoadStatus(
  detailsKey: FxWorkspaceDetailsKey | undefined,
  referencesStatus: FxWorkspaceLoadStatus,
  breaklinesStatus: FxWorkspaceLoadStatus
): FxWorkspaceLoadStatus {
  if (detailsKey === undefined) {
    return 'idle';
  }

  if (referencesStatus === 'pending' || breaklinesStatus === 'pending') {
    return 'pending';
  }

  if (referencesStatus === 'error' || breaklinesStatus === 'error') {
    return 'error';
  }

  return 'success';
}
